module.exports = __webpack_public_path__ + "img/11_life-skills.ccb93631.png";